import fetch from "auth/FetchInterceptor";

const fetchData = async (url) => {
  const response = await fetch(url);
  return response;
};
export default fetchData;
